import { Component } from "react";

import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

import Topbar from "./Topbar.jsx";

import Routing from "./Routing";

import AuthenticationContext from "../utility/AuthenticationContext";
import getAuthenticationWorker from "./AuthenticationWorker";

import "./App.css";
import { AuthenticationInfoType } from "../utility/types";

type IProps = {};

class AppFrame extends Component {
  state: {
    auth: AuthenticationInfoType | undefined;
  };

  constructor(props: IProps) {
    super(props);

    this.handleUserLoggedIn = this.handleUserLoggedIn.bind(this);
    this.signin = this.signin.bind(this);
    this.signout = this.signout.bind(this);

    getAuthenticationWorker().handleUserLoggedIn(this.handleUserLoggedIn);

    this.state = {
      auth: undefined,
    };
  }

  handleUserLoggedIn(userToken: any, userData: any) {
    const auth: AuthenticationInfoType = {
      accessToken: userToken.access_token,
      userData: userData,
    };

    this.setState({
      auth,
    });
  }

  signout() {
    getAuthenticationWorker().signout();
  }

  signin() {
    getAuthenticationWorker().signin();
  }

  render() {
    const auth = this.state.auth as AuthenticationInfoType;
    return (
      <Router>
        <AuthenticationContext.Provider value={auth}>
          <div id="header">
            <Topbar
              accessToken={auth && auth.accessToken}
              userName={auth && auth.userData && auth.userData.displayName}
              signin={this.signin}
              signout={this.signout}
            />
          </div>
          <Routing auth={auth} />
        </AuthenticationContext.Provider>
      </Router>
    );
  }
}

export default AppFrame;
